"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS = exports.PARAMS = exports.Device = void 0;
exports.compute_status = compute_status;
Object.defineProperty(exports, "devices", {
  enumerable: true,
  get: function get() {
    return _devices.devices;
  }
});
exports.get_default_model = get_default_model;
exports.get_device_attribute = get_device_attribute;
exports.get_device_factor = get_device_factor;
Object.defineProperty(exports, "i18nModel", {
  enumerable: true,
  get: function get() {
    return _devices.i18nModel;
  }
});
Object.defineProperty(exports, "i18nType", {
  enumerable: true,
  get: function get() {
    return _devices.i18nType;
  }
});
exports.is_empty_year = is_empty_year;
exports.is_valid = is_valid;
exports.is_valid_year = is_valid_year;
exports.setup = setup;
exports.year_ok = year_ok;
var _devices = require("./devices.js");
var _uuid = require("uuid");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // reexport devices and messages
// PARAMS isn't a constant !
// this can be changed by user code (eg l1p5 Main.vue)
var PARAMS = exports.PARAMS = {
  includes_empty_year: false,
  // used in the "flux" method
  damping_factor: 1,
  // in years, used in the "flux" method
  ignore_year: false,
  // used in the "flux" method
  lifetime_factor: 1.5,
  // used in the "flux" method to simulate a longer lifetime, or in the "stock" method to compute the default extended lifetime
  default_uncertainty: 30,
  lifetime_uncertainty: 1,
  kWh_to_CO2e: 0.084,
  get_default_model: get_default_model_ecodiag
};
var STATUS = exports.STATUS = {
  user_ko: 2,
  user_ok: 4,
  unknown: 6,
  unknown_year: 7,
  invalid_year: 8,
  csv_ok: 10
};

/**
 * Setup the library according to options
 *
 * @param {Object} params - the params to set
 */
function setup(params) {
  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      k = _Object$entries$_i[0],
      v = _Object$entries$_i[1];
    PARAMS[k] = v;
  }
}
function is_empty_year(y) {
  return !y || y === '';
}
function is_valid_year(y, method, ref_year) {
  return method === 'stock' || PARAMS.ignore_year || PARAMS.includes_empty_year && is_empty_year(y) || y <= ref_year && y > ref_year - PARAMS.damping_factor;
}
function year_ok(y, method, referenceYear) {
  return is_valid_year(y, method, referenceYear);
}
function compute_status(item, method, ref_year) {
  var check_year = function check_year(ok) {
    return !is_valid_year(item.year, method, ref_year) ? is_empty_year(item.year) ? STATUS.unknown_year : STATUS.invalid_year : ok;
  };
  if (item.details.filter(function (e) {
    return Boolean(e.csvdata);
  }).length === 0) {
    return Object.keys(_devices.devices).indexOf(item._type) !== -1 ? check_year(STATUS.user_ok) : STATUS.user_ko;
  } else {
    return item.score < 1 ? STATUS.unknown : check_year(STATUS.csv_ok);
  }
}
function is_valid(item, method, ref_year) {
  var status = compute_status(item, method, ref_year);
  return item.score >= 0 && (status === STATUS.user_ok || status === STATUS.csv_ok);
}
function get_default_model(type) {
  return PARAMS.get_default_model(type);
}
function my_erfinv(x) {
  var z = 0;
  var a = 0.1400122886866665; // = ((8*(Math.PI - 3)) / ((3*Math.PI)*(4 - Math.PI)))
  var sign_x;
  if (x == 0) {
    sign_x = 0;
  } else if (x > 0) {
    sign_x = 1;
  } else {
    sign_x = -1;
  }
  if (x != 0) {
    var tmp1 = Math.log(1 - x * x);
    var tmp2 = tmp1 / 2 + 2 / (Math.PI * a);
    z = Math.sqrt(Math.sqrt(tmp2 * tmp2 - tmp1 / a) - tmp2) * sign_x;
  }
  return z;
}
function LogNormal(mu, sigma) {
  // this.mu = mu
  // this.sigma = sigma

  var pdf = function pdf(x) {
    return Math.exp(-Math.pow(Math.log(x) - mu, 2) / (2 * sigma * sigma)) / (x * sigma * Math.sqrt(2 * Math.pi));
  };
  var cdf = function cdf(x) {
    return 0.5 * 0.5 * Math.erf((Math.log(x) - mu) / (Math.sqrt(2) * sigma));
  };
  var inv = function inv(p) {
    return Math.exp(mu + Math.sqrt(2 * sigma * sigma) * my_erfinv(2 * p - 1));
  };
  return {
    pdf: pdf,
    cdf: cdf,
    inv: inv
  };
}
function LogNormalFromMeanAndRelStdev(mean, relative_stdev) {
  var si2 = Math.log(Math.pow(relative_stdev, 2) + 1);
  return LogNormal(Math.log(mean) - 0.5 * si2, Math.sqrt(si2));
}

// Returns the attribute "attr" from a type/model pair
// (model is optional)
function get_device_attribute(type, model, attr) {
  var res = undefined;
  var device = _devices.devices[type];
  if (device) {
    res = device[attr];
    if (model && model != 'default' && _devices.devices[type].models && model in _devices.devices[type].models && _devices.devices[type].models[model][attr]) {
      res = _devices.devices[type].models[model][attr];
    }
  }
  return res;
}
function get_default_model_ecodiag(type) {
  if (_devices.devices[type] && _devices.devices[type].models) {
    var res = {
      desktop: 'ecodiag_avg_PC',
      printer: 'office_40_99kg'
    }[type];
    if (res) {
      return res;
    }
    return 'default';
  } else {
    return undefined;
  }
}
// Returns grey CO2 factor from a type/model pair
// (model is optional)
function get_device_factor(type, model) {
  function getmean(el) {
    if (el.mean) {
      return el.mean;
    } else {
      return el;
    }
  }
  var getstd = function getstd(el) {
    if (el.std) {
      return el.std;
    } else {
      return PARAMS.default_uncertainty / 100;
    } // default is 30%
  };
  if (!(type in _devices.devices)) {
    return {
      mean: 0,
      std: 0
    };
  }
  var device_CO2 = _devices.devices[type].grey_CO2;
  var mean = getmean(device_CO2);
  var std = getstd(device_CO2);
  if (model && model != 'default') {
    var model_CO2;
    if (_devices.devices[type].models[model].grey_CO2) {
      model_CO2 = _devices.devices[type].models[model].grey_CO2;
    } else {
      model_CO2 = _devices.devices[type].models[model];
    }
    mean = getmean(model_CO2);
    std = getstd(model_CO2);
  }
  return {
    mean: mean,
    std: std
  };
}
var Device = exports.Device = /*#__PURE__*/function () {
  function Device() {
    _classCallCheck(this, Device);
    this.id = (0, _uuid.v4)();
    this._type = null;
    this._model = null;
    this.nb = 1;
    this.lifetime = null;
    this.lifetime2 = null;
    this.year = null;
    this.score = 0;
    this.details = [];
    this.tag = '';
  }
  return _createClass(Device, [{
    key: "type",
    get: function get() {
      return this._type;
    },
    set: function set(v) {
      if (this._type != v) {
        this._type = v;
        this.model = get_default_model(this._type);
        this.update_from_type_and_model();
      }
    }
  }, {
    key: "model",
    get: function get() {
      return this._model;
    },
    set: function set(v) {
      if (this._model != v) {
        this._model = v;
        this.update_from_type_and_model();
      }
      // what else ?
    }

    // Shortcut to get_device_attribute (obsolete)
  }, {
    key: "get_yearly_consumption",
    get: function get() {
      return get_device_attribute(this.type, this.model, 'yearly_consumption');
    }
  }, {
    key: "update_from_type_and_model",
    value: function update_from_type_and_model() {
      this.lifetime = get_device_attribute(this.type, this.model, 'duration');
      this.lifetime2 = this.lifetime * +PARAMS.lifetime_factor;
      this.yearly_consumption = get_device_attribute(this.type, this.model, 'yearly_consumption');
      this.usage = get_device_attribute(this.type, this.model, 'usage');
    }
  }, {
    key: "compute_device_co2e",
    value:
    // Computes the estimated CO2e emissions of the input item,
    // as well as the inferior/superior bounds for the provided confidences (optional)
    // - method should be either 'stock' or 'flux'
    function compute_device_co2e(method, confidences) {
      var device_factor = get_device_factor(this.type, this.model);
      var lt = method == 'stock' ? this.lifetime : +PARAMS.damping_factor;
      var greyCO2 = this.nb * device_factor.mean / lt;
      var lt_bis = method == 'stock' ? this.lifetime2 : +PARAMS.damping_factor * +PARAMS.lifetime_factor;
      var greyCO2_bis = this.nb * device_factor.mean / lt_bis;
      var infs = [];
      var sups = [];
      if (confidences) {
        var distrib = LogNormalFromMeanAndRelStdev(device_factor.mean, device_factor.std);
        infs = Array(confidences.length);
        sups = Array(confidences.length);
        for (var i = 0; i < confidences.length; ++i) {
          infs[i] = this.nb * distrib.inv(0.5 - 0.5 * confidences[i] / 100) / lt;
          sups[i] = this.nb * distrib.inv(0.5 + 0.5 * confidences[i] / 100) / lt;
        }
      }
      var useCO2 = this.nb * this.get_yearly_consumption * PARAMS.kWh_to_CO2e;
      return {
        grey: greyCO2,
        // mean
        infs: infs,
        sups: sups,
        use: useCO2,
        grey2: greyCO2_bis // reduction objective
      };
    }

    /**
     * Try to find a translation for the device in devices
     *
     * @param {*} locale - locale to look for (e.g fr, en, ...)
     *
     * @returns {?string} the translation if any
     */
  }, {
    key: "i18nType",
    value: function i18nType(locale) {
      return (0, _devices.i18nType)(this.type, locale);
    }

    /**
     * Try to find a translation for the model in devices
     *
     * @param {*} locale - locale to look for (e.g fr, en, ...)
     *
     * @returns {?string} - the translation if any
     */
  }, {
    key: "i18nModel",
    value: function i18nModel(locale) {
      return (0, _devices.i18nModel)(this.type, this.model, locale);
    }
  }], [{
    key: "fromType",
    value: function fromType(type, params) {
      if (!params) params = {};
      var item = new Device();
      item.type = type; // this automatically sets model, lifetime, lifetime2, yearly_consumption, and usage from default values
      // now, let's update the model (this also sets lifetime, lifetime2, yearly_consumption, and usage from default values)
      if (params.model && type in _devices.devices && _devices.devices[type].models && params.model in _devices.devices[type].models || params.model == 'default') {
        item.model = params.model;
      }
      // now, let's update them if provided by params,
      // that is, copy all parameters but 'type' and 'model':
      for (var key in params) {
        if (key !== 'type' && key !== 'model' && key !== '_type' && key !== '_model') {
          var val = params[key];
          item[key] = val;
        }
      }
      return item;
    }

    /**
     *
     * Tries to find a good candidate in device based on the given string
     *
     * @param {String} type - string to match to the regexp type in devices
     * @param {String} model - string to match to the regexp model in devices
     *
     * @returns {Device} device - the matched Device
     */
  }, {
    key: "fromRegex",
    value: function fromRegex(type, model) {
      var score = 0;
      var item = {};
      item['score'] = 0;
      item['type'] = '';
      item['model'] = '';
      for (var dev_key in _devices.devices) {
        var dev = _devices.devices[dev_key];
        var dev_score = 0;
        var mod_score = 0;
        if (dev.regex && type) {
          if (type.search(dev.regex) >= 0) {
            dev_score = 1;
          }
        }
        if (dev_score > 0 && score == 0) {
          // we already found a better match
          score = dev_score;
          item['score'] = score;
          item['type'] = dev_key;
          item['model'] = get_default_model(dev_key);
        }
        if (dev.models && model) {
          for (var m_key in dev.models) {
            var m = dev.models[m_key];
            if (m.regex) {
              if (model.search(m.regex) >= 0) {
                mod_score = 1;
              }
              if (dev_score + mod_score > score) {
                // we found a better candidate
                score = dev_score + mod_score;
                item['score'] = score;
                item['type'] = dev_key;
                item['model'] = m_key;
                if (score == 2) {
                  return Device.fromType(item['type'], item);
                } else {
                  break;
                }
              }
            }
          }
        }
      }

      // after a lookup we return the best candidate so far ...
      if (score > 0) {
        return Device.fromType(item['type'], item);
      }
      // if no good candidate, throw
      throw new Error("No good enough device found for ".concat(type, " and ").concat(model, "\""));
    }
  }]);
}(); // make some getter enumerable (backward compat)
Object.defineProperty(Device.prototype, 'type', {
  enumerable: true
});
Object.defineProperty(Device.prototype, 'model', {
  enumerable: true
});